/**
 * Runs `task`, then `cleanup` on every path: a resolved value, a rejected
 * promise and a synchronous throw. The task's value or error still reaches the
 * caller, after the cleanup has run. The task starts in the calling tick.
 *
 * Use it in a component or hook body in place of `try/finally` (or a `try`
 * with no `catch`): the React Compiler cannot lower either, so the
 * compiler-backed `react-hooks` lint rules silently skip the whole function.
 * Keeping the `try` here keeps those rules on for the caller.
 *
 * A failure that must be logged before the cleanup (log, then reload) is
 * caught inside the task, so the log lands before the cleanup runs.
 */
export async function runWithCleanup<T>(
  task: () => T | Promise<T>,
  cleanup: () => void
): Promise<T> {
  try {
    return await task();
  } finally {
    cleanup();
  }
}
